// frontend/src/features/livestock/monthGroups.ts
// Photos under month headings, like the camera roll: the photo inbox and Tank Shots.

import dayjs, { type Dayjs } from 'dayjs';

/**
 * A server datetime in the browser's time zone. The server's datetimes carry
 * microseconds ("...05.123456Z"); parsed with milliseconds, which every engine reads.
 */
export function parseServerDate(iso: string): Dayjs {
  return dayjs(iso.replace(/(\.\d{3})\d+/, '$1'));
}

export interface MonthGroup<T> {
  /** "2025-09" */
  key: string;
  /** "Sep 2025" */
  label: string;
  items: T[];
}

/** Consecutive items of the same month, in the order given (oldest or newest first alike). */
export function groupByMonth<T>(items: T[], dateOf: (item: T) => string): MonthGroup<T>[] {
  const groups: MonthGroup<T>[] = [];
  for (const item of items) {
    const when = parseServerDate(dateOf(item));
    const key = when.format('YYYY-MM');
    const last = groups[groups.length - 1];
    if (last && last.key === key) {
      last.items.push(item);
    } else {
      groups.push({ key, label: when.format('MMM YYYY'), items: [item] });
    }
  }
  return groups;
}
